import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { PlannerEcsSystem } from './System';
import { AlbedoColor } from '../SceneApi';
import EntityColorComponent from '../components/EntityColorComponent';
/**
 * Marks entity with specified color
 */
export class EntityColorSystem extends PlannerEcsSystem {
    constructor(coreApi) {
        super(coreApi, 'EntityColorSystem', EntityColorComponent.id);
    }
    onAdd(entity, newComponent) {
        this.setColorOnEntity(entity, newComponent.color);
    }
    onUpdate(entity, oldComponent, newComponent) {
        this.setColorOnEntity(entity, newComponent.color);
    }
    onRemove(entity) {
        this.setColorOnEntity(entity, AlbedoColor.NONE);
    }
    setColorOnEntity(entity, color) {
        const parts = entity.hasComponent(ComponentIds.ASSEMBLY_STRUCTURE_COMPONENT_ID)
            ? HierarchyUtils.children(entity)
            : [entity];
        parts.forEach(part => {
            const objectId = this.coreApi.entities.getObjectId(part);
            if (objectId) {
                this.coreApi.scene?.setObjectBaseColor(color, objectId);
            }
        });
    }
}
//# sourceMappingURL=EntityColorSystem.js.map